let connect = require("react-redux").connect;
import React from "react";
let Link = require("react-router").Link;

class ModerationNavigation extends React.Component {
    render() {
        let creatorsActiveClass,
            underReviewActiveClass,
            saveForLaterActiveClass,
            suspendedActiveClass,
            saveForLaterBadge,
            suspendedBadge,
            newUploadBadge;

        switch (this.props.slug) {
            case "creators":
                creatorsActiveClass = "active";
                underReviewActiveClass = "";
                saveForLaterActiveClass = "";
                suspendedActiveClass = "";
                break;
            case "under-review":
                creatorsActiveClass = "";
                underReviewActiveClass = "active";
                saveForLaterActiveClass = "";
                suspendedActiveClass = "";
                break;
            case "save-for-later":
                creatorsActiveClass = "";
                underReviewActiveClass = "";
                saveForLaterActiveClass = "active";
                suspendedActiveClass = "";
                break;
            case "suspended":
                creatorsActiveClass = "";
                underReviewActiveClass = "";
                saveForLaterActiveClass = "";
                suspendedActiveClass = "active";
                break;
        }

        if (this.props.newUploads) {
            newUploadBadge = (
                <span className="badge">
                    {this.props.newUploads} / {this.props.newIcons}
                </span>
            );
        }

        if (this.props.savedUploads) {
            saveForLaterBadge = (
                <span className="badge">
                    {this.props.savedUploads} / {this.props.savedIcons}
                </span>
            );
        }

        if (this.props.suspendedUploads) {
            suspendedBadge = (
                <span className="badge">
                    {this.props.suspendedUploads} / {this.props.suspendedIcons}
                </span>
            );
        }

        return (
            <section className="moderation-navigation row">
                <Link
                    to={"/fort/modparty/"}
                    className="ui_logo col-xs-2"
                    title={"ModParty"}
                >
                    {"ModParty"}
                </Link>
                <ul className="nav nav-tabs col-xs-8">
                    <li role="presentation" className={creatorsActiveClass}>
                        <Link
                            to={"/fort/modparty/creators/"}
                            title={"New Uploads"}
                        >
                            {"New Uploads"} {newUploadBadge}
                        </Link>
                    </li>
                    <li role="presentation" className={saveForLaterActiveClass}>
                        <Link
                            to={"/fort/modparty/save-for-later/"}
                            title={"Saved For Later"}
                        >
                            {"Saved For Later"} {saveForLaterBadge}
                        </Link>
                    </li>
                    <li role="presentation" className={suspendedActiveClass}>
                        <Link
                            to={"/fort/modparty/suspended/"}
                            title={"Suspended"}
                        >
                            {"Suspended"} {suspendedBadge}
                        </Link>
                    </li>
                    <li role="presentation" className={underReviewActiveClass}>
                        <Link
                            to={"/fort/modparty/under-review/"}
                            title={"Under Review"}
                        >
                            {"Under Review"}
                        </Link>
                    </li>
                </ul>
                <a href="/fort/" className="logout col-xs-2">Back To Fort</a>
            </section>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let newUploads = 0,
        savedUploads = 0,
        suspendedUploads = 0,
        newIcons = 0,
        savedIcons = 0,
        suspendedIcons = 0;

    if (state.uploads.counts) {
        newUploads = state.uploads.counts.new_batches;
        savedUploads = state.uploads.counts.saved_batches;
        suspendedUploads = state.uploads.counts.suspended_batches;
        newIcons = state.uploads.counts.new_uploads;
        savedIcons = state.uploads.counts.saved_uploads;
        suspendedIcons = state.uploads.counts.suspended_uploads;
    }

    return {
        newUploads,
        savedUploads,
        suspendedUploads,
        newIcons,
        savedIcons,
        suspendedIcons
    };
}

module.exports = connect(mapStateToProps, {})(ModerationNavigation);
